/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
import{Uniform as r}from"../../../../webgl/Uniform.js";class e extends r{constructor(r,e,o){super(r,"vec2",0,(s,t)=>s.setUniform2fv(r,e(t),o))}}export{e as Float2BindUniform};
